import React from "react";
import { CheckIcon, GlobeIcon, FlameIcon, ShieldCheckIcon } from "lucide-react";
import { images } from "../../data/landing";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { TransformCta } from "../TransformCta";
const stack = [{
  title: "The Six-Volume Collection",
  text: "Diagnostic, Treatment Planning, Cardiovascular Protection, Kidney Care, Insulin Management and Long-Term Care Blueprints.",
  value: 79
}, {
  title: "Five Specialized Clinical Tools",
  text: "Renal Medication Review Matrix, Insulin Consultation Planner, Annual Diabetes Review Checklist, Patient Conversation Framework, and Clinical Review & Documentation Checklist.",
  value: 87
}];
const perks = ["One-Time Payment", "No Monthly Fees", "Instant Digital Delivery", "Access to Your Purchased Edition"];
const SPOTS_LEFT = 7;
const FILL = 93;
export function Offer() {
  return <section id="offer" className="px-4 py-16 sm:px-5" data-id="element-193" data-mp="1ou93oxcnpyc">
      <div className="mx-auto max-w-2xl overflow-hidden rounded-[2rem] bg-white shadow-2xl ring-4 ring-navy" data-id="element-194" data-mp="1napppgecysc">
        <div className="bg-navy px-5 py-6 text-center text-white" data-id="element-195" data-mp="1fmdh11mr6acy">
          <p className="text-sm font-extrabold uppercase tracking-[0.16em] text-sky-300" data-id="element-196" data-mp="1fl2awv5u4qio">Your special launch offer</p>
          <h2 className="mt-2 font-serif text-[1.75rem] font-extrabold leading-tight sm:text-4xl" data-id="element-197" data-mp="1bmmsz5om28c4">
            Everything included in Diabetes Clinical Blueprint™
          </h2>
        </div>

        <div className="px-5 pb-8 pt-4 sm:px-8" data-id="element-198" data-mp="23e2boon1rax2">
          <img src={images.mockup} alt="Diabetes Clinical Blueprint complete collection" className="mx-auto w-full" loading="lazy" data-id="element-199" data-mp="1za4eijha8a6n" />

          <ul className="mt-2 divide-y divide-navy/10" data-id="element-200" data-mp="1uhtelgmjkoe3">
            {stack.map(s => <li key={s.title} className="flex gap-3 py-4" data-id="element-201" data-mp="1pk1n2npt74af">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-202" data-mp="2n0gwyoa5lpbh">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-203" data-mp="2i8gno5871k28" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-204" data-mp="3160ort2k8ib8">
                  <p className="text-lg font-bold text-ink" data-id="element-205" data-mp="364al4700toyf">{s.title}</p>
                  <p className="mt-1 text-[15px] leading-snug text-muted" data-id="element-206" data-mp="366obw3no4f06">{s.text}</p>
                  <p className="mt-1.5 text-sm text-navy" data-id="element-207" data-mp="2scx3iylob161">
                    Reference value: <s className="font-bold text-alert" data-id="element-208" data-mp="2wdfxozb1gjbe">${s.value}</s>
                  </p>
                </div>
              </li>)}
          </ul>

          <div className="mt-2 rounded-2xl bg-cream p-5 text-center" data-id="element-209" data-mp="2ndsuq92nv5g8">
            <p className="text-lg text-muted" data-id="element-210" data-mp="2nbzlcm0ny74j">
              Total reference value: <s className="font-bold text-alert" data-id="element-211" data-mp="29fmf691kxs5d">$166</s>
            </p>
            <p className="mt-2 text-base font-semibold text-ink" data-id="element-212" data-mp="2dfd5kbn7269d">Get the complete collection today for just</p>
            <p className="mt-1 font-serif text-7xl font-black leading-none text-cta" data-id="element-213" data-mp="7nzlu0u7tl5q">
              $27<span className="ml-1 align-top font-sans text-lg font-bold text-ink" data-id="element-214" data-mp="bota4vbkl1z5">USD</span>
            </p>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-left" data-id="element-215" data-mp="1w7lwy5m248is">
              {perks.map(p => <li key={p} className="flex items-start gap-1.5 text-sm font-semibold leading-snug text-ink" data-id="element-216" data-mp="1s60bvwzdcnxi">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-217" data-mp="25x5dv5q7lsb0" />
                  {p}
                </li>)}
            </ul>
          </div>

          <div className="mt-6 rounded-2xl border-2 border-alert/30 bg-red-50 p-4" data-id="element-218" data-mp="2ft03wlwripnt">
            <p className="flex items-center justify-center gap-2 text-center text-[15px] font-extrabold text-alert" data-id="element-219" data-mp="2auf4upt8yc0y">
              <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-220" data-mp="2oupvpsuk3qm4" />
              Only {SPOTS_LEFT} spots left at the promotional price!
            </p>
            <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-alert/20" role="progressbar" aria-valuenow={FILL} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-221" data-mp="ugoy1baqt9nm">
              <div className="h-full rounded-full bg-alert" style={{
              width: `${FILL}%`
            }} data-id="element-222" data-mp="rvr0fyc3dvjf" />
            </div>
            <p className="mt-2 text-center text-xs font-semibold text-ink" data-id="element-223" data-mp="vx2tkdu6cywd">{FILL}% of promotional spots already claimed</p>
          </div>

          <div className="mt-6" data-id="element-224" data-mp="10vnnxwmqwocw">
            <CtaButton label="Yes, I want Diabetes Clinical Blueprint" data-id="element-225" data-mp="15wtnadawv9ve" />
            <p className="mt-3 text-center text-sm text-muted" data-id="element-226" data-mp="88t677hbc334">$27 USD · One-Time Payment · 7-Day Money-Back Guarantee</p>
          </div>

          <Countdown data-id="element-227" data-mp="d8xql8lcdhym" />

          <div className="mt-6 flex gap-3 rounded-2xl bg-brandsoft p-4" data-id="element-228" data-mp="d85vrzzkjo9e">
            <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-229" data-mp="i5xw9iea4ip7" />
            <p className="text-sm leading-snug text-navy" data-id="element-230" data-mp="mxz9p7n6ofgt">
              <strong data-id="element-231" data-mp="3lnpkclpaoii4">Automatic currency conversion:</strong> the price is shown and charged in your local currency at checkout.
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-xs font-semibold text-muted" data-id="element-232" data-mp="3qlhku4409cxx">
            <ShieldCheckIcon className="h-4 w-4 text-cta" aria-hidden="true" data-id="element-233" data-mp="3j2rmr8qn94dx" />
            Secure checkout · Your data is protected
          </p>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-234" data-mp="394aqbw8xrxkh">
        <h3 className="font-serif text-2xl font-extrabold text-ink sm:text-3xl" data-id="element-235" data-mp="396wurn0j5wyh">Why am I offering it at this price?</h3>
        <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-236" data-mp="304xfaz55z0xn">
          I created Diabetes Clinical Blueprint to make a structured collection of practical reference materials accessible without requiring a large upfront investment. My goal is to help healthcare professionals organize their work more efficiently — not to make them pay for another expensive educational program before they can start using the resources.
        </p>
        <p className="mt-4 text-lg font-semibold text-ink" data-id="element-237" data-mp="2gf4x46s5x5j6">You receive all six volumes and all five tools in one purchase.</p>
      </div>
      <TransformCta label="Claim my launch price now" note="$27 USD · The price is charged in the currency displayed at checkout." data-id="element-238" data-mp="2ch76r0mnode7" />
    </section>;
}